<div [class]="gridClass()">
  @for (input of inputs(); track input.formControlName || input.name || $index) {
    @let isVisible = fieldVisibility()[$index];
    @let isSection =
      input.type === FormInputType.DIVISOR || input.type === FormInputType.SUBDIVISOR;

    <div [class]="input.class || 'col-12'" [hidden]="!isVisible && !isSection">
      @switch (input.type) {
        @case (FormInputType.DIVISOR) {
          @let status = getSectionStatus(input.name);
          <div
            class="divisor-container s-mt-5 s-mb-4 d-flex align-items-center justify-content-between"
            (click)="toggleSection(input.name)"
            style="cursor: pointer"
          >
            <h3 class="m-0 bebas-font d-flex align-items-center flex-wrap gap-3">
              {{ input.name | translate }}
              @if (input.headerActionControl) {
                <mat-checkbox
                  color="primary"
                  [formControl]="input.headerActionControl"
                  (click)="$event.stopPropagation()"
                >
                  <span class="header-action-label">{{ input.headerActionLabel | translate }}</span>
                </mat-checkbox>
              }
              @if (status.hasRequired) {
                <mat-icon [class]="status.isComplete ? 'text-success ms-2' : 'text-danger ms-2'">
                  {{ status.isComplete ? 'check_circle' : 'error' }}
                </mat-icon>
              }
            </h3>
            <mat-icon [class.rotate-180]="!isSectionCollapsed(input.name)">expand_more</mat-icon>
          </div>
        }

        @case (FormInputType.SUBDIVISOR) {
          <!-- Subdivisor é apenas uma sinalização/legenda, não expande/recolhe. -->
          <div class="subdivisor-container s-mt-4 s-mb-3 d-flex align-items-center">
            <h4 class="m-0 bebas-font">
              {{ input.name | translate }}
            </h4>
          </div>
        }

        @case (FormInputType.TEXT) {
          <z-input
            [formControlRef]="getControl(input.formControlName!)"
            [label]="input.name"
            [mask]="input.mask || ''"
            [prefix]="input.prefix || ''"
            [required]="input.required ?? false"
            [id]="getInputId(input)"
            [hint]="input.hint || ''"
            [autocomplete]="input.autocomplete || 'off'"
          ></z-input>
        }

        @case (FormInputType.PASSWORD) {
          <z-input-password
            [formControlRef]="getControl(input.formControlName!)"
            [label]="input.name"
            [required]="input.required ?? false"
            [id]="getInputId(input)"
            [autocomplete]="input.autocomplete || 'new-password'"
          ></z-input-password>
        }

        @case (FormInputType.SELECT) {
          @if (input.select; as select$) {
            <z-select
              [formControlRef]="getControl(input.formControlName!)"
              [label]="input.name"
              [items]="(select$ | async) || []"
              [required]="input.required ?? false"
              [multiple]="input.multiple ?? false"
              [hint]="input.hint || ''"
            ></z-select>
          }
        }

        @case (FormInputType.CEP) {
          <z-input
            [label]="input.name"
            [formControlRef]="getControl(input.formControlName!)"
            [required]="input.required ?? false"
            cepValidator
            [mask]="MASK.CEP"
            [placeholder]="MASK.CEP"
          ></z-input>
        }

        @case (FormInputType.CPF) {
          <z-input
            [label]="input.name"
            [formControlRef]="getControl(input.formControlName!)"
            [required]="input.required ?? false"
            [mask]="MASK.CPF"
            [placeholder]="MASK.CPF"
          ></z-input>
        }

        @case (FormInputType.CNPJ) {
          <z-input
            [label]="input.name"
            [formControlRef]="getControl(input.formControlName!)"
            [required]="input.required ?? false"
            [mask]="MASK.CNPJ"
            [placeholder]="MASK.CNPJ"
            [uppercase]="true"
            [validateCnpj]="true"
          ></z-input>
        }

        @case (FormInputType.DATE) {
          <app-datepicker
            [label]="input.name"
            [formControlRef]="getControl(input.formControlName!)"
            [required]="input.required ?? false"
            [min]="input.minDate"
            [max]="input.maxDate"
            [weekFilter]="input.weekFilter || false"
            [viewMode]="input.viewMode || 'month'"
          ></app-datepicker>
        }

        @case (FormInputType.MONTH) {
          <app-monthpicker
            [label]="input.name"
            [formControlRef]="getControl(input.formControlName!)"
            [required]="input.required ?? false"
          ></app-monthpicker>
        }

        @case (FormInputType.NUMBER) {
          <z-input
            [label]="input.name"
            [formControlRef]="getControl(input.formControlName!)"
            [required]="input.required ?? false"
            [type]="'number'"
          ></z-input>
        }

        @case (FormInputType.CHECKBOX) {
          <div class="d-flex align-items-center h-100">
            <mat-checkbox color="primary" [formControl]="getControl(input.formControlName!)">
              {{ input.name | translate }}
            </mat-checkbox>
          </div>
        }

        @case (FormInputType.RADIO) {
          <label class="d-block">{{ input.name | translate }}@if (input.required) {
              <span class="text-danger"> *</span>
            }</label>
          @if (input.cardStyle) {
            <div class="radio-card-group" [class.radio-card-group--inline]="input.radioInline">
              @for (radio of (input.radios ?? []); track radio.value) {
                <button type="button" class="radio-card"
                  [class.radio-card--selected]="getControl(input.formControlName!).value === radio.value"
                  (click)="getControl(input.formControlName!).setValue(radio.value)">
                  <div class="radio-card__row">
                    <span class="radio-card__label">{{ radio.name | translate }}</span>
                    @if (getControl(input.formControlName!).value === radio.value) {
                      <mat-icon class="radio-card__check">check</mat-icon>
                    }
                  </div>
                </button>
              } @empty {
                @for (opt of [{name: 'COMMON.YES', value: true}, {name: 'COMMON.NO', value: false}]; track opt.value) {
                  <button type="button" class="radio-card"
                    [class.radio-card--selected]="getControl(input.formControlName!).value === opt.value"
                    (click)="getControl(input.formControlName!).setValue(opt.value)">
                    <div class="radio-card__row">
                      <span class="radio-card__label">{{ opt.name | translate }}</span>
                      @if (getControl(input.formControlName!).value === opt.value) {
                        <mat-icon class="radio-card__check">check</mat-icon>
                      }
                    </div>
                  </button>
                }
              }
            </div>
          } @else {
            <mat-radio-group [formControl]="getControl(input.formControlName!)">
              @for (radio of input.radios; track radio.value) {
                <mat-radio-button color="primary" [value]="radio.value">{{
                  radio.name | translate
                }}</mat-radio-button>
              } @empty {
                <mat-radio-button color="primary" [value]="true">{{
                  'COMMON.YES' | translate
                }}</mat-radio-button>
                <mat-radio-button color="primary" [value]="false">{{
                  'COMMON.NO' | translate
                }}</mat-radio-button>
              }
            </mat-radio-group>
          }
        }

        @case (FormInputType.CURRENCY) {
          <mat-form-field class="w-100" appearance="outline">
            <mat-label>{{ input.name | translate }}</mat-label>
            <input
              matInput
              style="text-align: left"
              [id]="getInputId(input) ? 'input-' + getInputId(input) : ''"
              [formControl]="getControl(input.formControlName!)"
              currencyMask
              [required]="input.required ?? false"
            />
          </mat-form-field>
        }

        @case (FormInputType.CPF_CNPJ) {
          <z-input
            [label]="input.name"
            [formControlRef]="getControl(input.formControlName!)"
            [required]="input.required ?? false"
            [mask]="'000.000.000-00||00.000.000/0000-00'"
            [autocomplete]="input.autocomplete || 'off'"
          ></z-input>
        }

        @case (FormInputType.FILE) {
          <div class="address-extra-card">
            <div class="address-extra-card__header">
              <mat-icon class="address-extra-card__icon">description</mat-icon>
              <div>
                <p class="address-extra-card__title">
                  {{ input.name | translate }}@if (input.required) {<strong style="color: red;"> *</strong>}
                </p>
                @if (input.hint) {
                  <p class="address-extra-card__subtitle">{{ input.hint }}</p>
                }
              </div>
            </div>
            <app-file-uploader
              [formControlRef]="getControl(input.formControlName!)"
              [multiple]="input.multiple ?? false"
              [accept]="input.accept ?? []"
              [existingFiles]="input.existingFiles ?? []"
              (fileDownload)="input.onExistingFileDownload?.($event)"
              (existingFileRemoved)="input.onExistingFileRemove?.($event)"
            ></app-file-uploader>
          </div>
        }
      }
    </div>
  }
</div>
